module.exports = __webpack_public_path__ + "static/img/1.de4b6eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news15/1.png
// module id = yQjE
// module chunks = 1